import {HoleType} from "./CardBacks";

export class CardCreatorStyle {
  id: number = 0;
  sponsor: number = 0;
  style: string = "";
  paid_for: boolean = false;
  approved: boolean = false;
  last_used: string = "";
  advertisement: boolean = false;
  card_back: number = 0;
  height: number = 0;
  width: number = 0;
  uploaded_image: string = "";
  image_pos_x: number = 0;
  image_pos_y: number = 0;
  image_size_width: number = 0;
  image_size_height: number = 0;
  background_color: string = "";
  text_items: StyleCreatorText[] = [];
  cutouts: StyleCreatorCutout[] = [];
  hue: number = 0;
  saturation: number = 0;
  luminosity: number = 0;

  constructor() {}
}

export class StyleCreatorText {
  text: string = "";
  font: string = "";
  font_size: number = 20;
  font_color: string = "";
  font_pos_x: number = 0;
  font_pos_y: number = 0;

  constructor() {}
}

export class StyleCreatorCutout {
  x: number = 0;
  y: number = 0;
  width: number = 0;
  height: number = 0;
  type: HoleType = HoleType.square;
  borderWidth: number = 0;
  borderColor: string = '#FFFFFF';

  constructor() {
  }
}
